var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ShowDocument" },
    [
      _c("div", { staticClass: "button-holder arrow-btn" }, [
        _c("div", { staticClass: "btn-item back-item" }, [
          _c(
            "button",
            {
              staticClass: "back",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.backToList.apply(null, arguments)
                },
              },
            },
            [
              _c("img", {
                staticClass: "long-arrow light-arrow",
                attrs: { src: "/img/long-arrow.png", alt: "" },
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "long-arrow dark-arrow",
                attrs: { src: "/img/long-arrow-dark.png", alt: "" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Documents")]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.isDeleteDocument
        ? _c("delete-document", { attrs: { file: _vm.item } })
        : _c("form", { staticClass: "gen-form gen-doc-form" }, [
            _c("div", { staticClass: "gen-fieldset__item" }, [
              _c("span", { staticClass: "key" }, [_vm._v("ID")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.item.id ? _vm.item.id : "")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gen-fieldset__item" }, [
              _c("span", { staticClass: "key" }, [_vm._v("Title")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.item.title)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gen-fieldset__item" }, [
              _c("span", { staticClass: "key" }, [_vm._v("Сreated at")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.item.created_at ? _vm.item.created_at : "") +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gen-fieldset__item" }, [
              _c("span", { staticClass: "key" }, [_vm._v("Сreated by")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.item.user_name ? _vm.item.user_name : "") +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gen-fieldset__item" }, [
              _c("span", { staticClass: "key" }, [_vm._v("Format")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.item.type)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gen-fieldset__item" }, [
              _c("span", { staticClass: "key" }, [_vm._v("Notes")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.item.comments)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "button-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "btn",
                  on: {
                    click: function ($event) {
                      return _vm.deleteDocument()
                    },
                  },
                },
                [_vm._v("Delete")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "button-holder" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn",
                    attrs: {
                      href: "/documents/" + _vm.item.path,
                      download: "",
                    },
                  },
                  [_vm._v("Download")]
                ),
              ]),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }